import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

// PrimeNG
import {StepsModule} from 'primeng/steps';
import {TabViewModule} from 'primeng/tabview';
import {ButtonModule} from 'primeng/button';
import {InputTextModule} from 'primeng/inputtext';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';

// Components
import {PaymentDetailsComponent} from './payment-details/payment-details.component';
import {PaymentDetailsFormComponent} from './payment-details/payment-details-form/payment-details-form.component';
import {PaymentMethodComponent} from './payment-details/payment-method/payment-method.component';
import {PaymentStatusComponent} from './payment-details/payment-status/payment-status.component';
import {PaymentCompletedComponent} from './payment-completed/payment-completed.component';
import {StripeDetailsComponent} from './stripe-details/stripe-details.component';
import {PaymentSummaryComponent} from './payment-details/payment-summary/payment-summary.component';

// Shared
import {SharedModule} from '../shared/shared.module';
import {AuthGuardService} from '../../core/services';
import {PaymentFlowService} from './payment-flow.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: 'payment',
        children: [
          {
            path: '',
            component: PaymentDetailsComponent,
            canActivate: [AuthGuardService],
          },
          {
            path: 'completed',
            component: PaymentCompletedComponent,
            canActivate: [AuthGuardService],
          },
          {
            path: 'stripe',
            component: StripeDetailsComponent,
            canActivate: [AuthGuardService],
          },
        ],
      },
    ]),
    StepsModule,
    TabViewModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
    SharedModule,
  ],
  declarations: [
    PaymentDetailsComponent,
    PaymentDetailsFormComponent,
    PaymentMethodComponent,
    PaymentStatusComponent,
    PaymentCompletedComponent,
    StripeDetailsComponent,
    PaymentSummaryComponent,
  ],
  providers: [PaymentFlowService],
  exports: [PaymentDetailsComponent],
})
export class PaymentModule {}
